import { Field, InputType } from 'type-graphql'
import type { IAction } from '../../action/IAction'
import type { PaymentGatewayObject } from '../PaymentGatewayObject'
import type { PaymentGatewayProvider } from '../PaymentGatewayProviderEnum'

@InputType()
export class CancelUncapturedPaymentArgs {
  @Field(() => String)
  paymentIntent: string

  @Field(() => String)
  gatewayProvider?: PaymentGatewayProvider
}

export interface ICancelUncapturedPayment extends IAction<PaymentGatewayObject, CancelUncapturedPaymentArgs> {}
